/** Сообщение, которое переживает переход на другой экран («Добавлено: 3», «Тест выдан»). */
export type NoticeKind = 'ok' | 'info';

export interface WorkspaceNotice {
  kind: NoticeKind;
  text: string;
}

let pending: WorkspaceNotice | null = null;

export function pushNotice(notice: WorkspaceNotice): void {
  pending = notice;
}

/**
 * Забрать сообщение: показывается один раз на экране, куда перешли.
 * Вызывать только в `useEffect`, не в инициализаторе `useState`: под `<React.StrictMode>` (`npm start`)
 * компонент рендерится дважды, и второй вызов вернул бы null, а сообщение пропало бы.
 */
export function takeNotice(): WorkspaceNotice | null {
  const notice = pending;
  pending = null;
  return notice;
}
